var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("credit-report-table-loader")
    : _c(
        "div",
        [
          _vm.creditReportsData.length
            ? _c("v-client-table", {
                ref: "creditReportTable",
                staticClass:
                  "w-100 vue-custom-table no-pagination credit-report-table text-center",
                attrs: {
                  data: _vm.creditReportsData,
                  columns: _vm.columnsTable,
                  options: _vm.options,
                  name: "creditReportTable",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "name",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              _vm._s(row.firstName) + " " + _vm._s(row.lastName)
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "dateObtained",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm._f("formatDateUTCCustom")(
                                    row.requestedAt,
                                    "MMM. DD, YYYY"
                                  )
                                ) +
                                "\n      "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "authDate",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm._f("formatDateUTCCustom")(
                                    row.authorizationDate,
                                    "MMM. DD, YYYY"
                                  )
                                ) +
                                "\n      "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "status",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.success
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "capitalize badge badge-success mb-0",
                                },
                                [
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(_vm.$t("global.words.success")) +
                                      "\n      "
                                  ),
                                ]
                              )
                            : !row.error || !row.error.length
                            ? _c(
                                "p",
                                {
                                  staticClass: "capitalize badge badge-danger",
                                },
                                [
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm.$t("global.words.failed")
                                        )
                                      ) +
                                      "\n      "
                                  ),
                                ]
                              )
                            : _c("notification-popover", {
                                attrs: {
                                  title: _vm.getPopoverTitle(row.error),
                                  triggers: "hover",
                                  type: "error",
                                  placement: "top",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "popoverTarget",
                                      fn: function () {
                                        return [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "capitalize clickable badge badge-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      _vm.$t(
                                                        "global.words.failed"
                                                      )
                                                    )
                                                  ) +
                                                  "\n          "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "popoverContent",
                                      fn: function () {
                                        return [
                                          _c("div", { staticClass: "p-2" }, [
                                            _c(
                                              "ul",
                                              { staticClass: "bullet px-3" },
                                              _vm._l(
                                                row.error,
                                                function (err, index) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key:
                                                        err.code + "-" + index,
                                                    },
                                                    [
                                                      _c("h6", [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "finishWithDot"
                                                              )(err.description)
                                                            ) +
                                                            "\n                "
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                        ]
                      },
                    },
                    {
                      key: "submit",
                      fn: function (ref) {
                        var index = ref.index
                        var row = ref.row
                        return [
                          row.success
                            ? _c(
                                "div",
                                { staticClass: "form-group-checkbox" },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.left",
                                          value: {
                                            title: _vm.$t(
                                              "tables.messages.oneReportPerApplicant"
                                            ),
                                            disabled:
                                              !_vm.disableSubmitToLenderCheck(
                                                row
                                              ),
                                          },
                                          expression:
                                            "{\n            title: $t('tables.messages.oneReportPerApplicant'),\n            disabled: !disableSubmitToLenderCheck(row)\n          }",
                                          modifiers: { left: true },
                                        },
                                      ],
                                      staticClass:
                                        "pretty p-icon p-jelly p-smooth p-curve mr-0",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "checkbox",
                                        attrs: {
                                          id: index,
                                          type: "checkbox",
                                          disabled:
                                            _vm.disableSubmitToLenderCheck(row),
                                        },
                                        domProps: {
                                          checked: row.submitToLender,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeSubmitToLender(row)
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "state p-success" },
                                        [
                                          _c("i", {
                                            staticClass: "icon fa fa-check",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "hidden-text",
                                              attrs: { for: index },
                                            },
                                            [_vm._v("Checkbox")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "actions",
                      fn: function (ref) {
                        var row = ref.row
                        var index = ref.index
                        return [
                          _c("action-buttons", {
                            ref: "actionButtons-" + index,
                            attrs: {
                              "is-disabled-buttons": !row.success,
                              "allow-preview": !!row.creditReportSummary,
                              disabled:
                                _vm.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY,
                            },
                            on: {
                              copy: function ($event) {
                                return _vm.handleCopyLiabilities({
                                  row: row,
                                  index: index,
                                })
                              },
                              preview: function ($event) {
                                return _vm.handlePreview({
                                  row: row,
                                  index: index,
                                })
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1950652965
                ),
              })
            : _c(
                "no-results",
                {
                  attrs: {
                    "img-src": require("@Shared/@Assets/img/application-missing.png"),
                  },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.$t("tables.messages.emptyCreditReports")) +
                      "\n  "
                  ),
                ]
              ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }